import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/interim/frontend/app/components/CardsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/interim/frontend/app/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/interim/frontend/app/components/LatestDevelopmentSection.tsx");
